
const constants = {
    ALTERNATIVE: 'ALTERNATIVE',
    DEFAULT: 'DEFAULT'
}

export default constants
